import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { Button, message, Input, Card, Form, Select, Col, Space, Row, Popconfirm, Table } from 'antd';
import { SEARCH_ITEM_COL, TABLE_DATA_DEFAULT } from '@/scripts/config';
// import useSearchList from '@/hooks/useSearchList';
import dayjs from 'dayjs';

const pageKey = 'HplAccountList'; //页面身份
export default function HplAccountList() {
    const [dataSource, setState] = useState([]);
    const [promptText, setPromptText] = useState([]);
    const [editingKey, setEditingKey] = useState(null); // 当前正在编辑的行 id
    const [editingData, setEditingData] = useState({}); // 编辑中的临时数据
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        ajax.get('/hpl/account/show')
            .then((response) => {
                const data = response.map((item) => {
                    item.update_time = item.update_time ? dayjs(item.update_time).format('YYYY-MM-DD HH:mm:ss') : null;
                    return item;
                });
                setState(data);
            })
            .catch((err) => {
                console.log(err);
            });
        ajax.get('/hpl/account/num')
            .then((response) => {
                setPromptText(response);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    // 清零账号
    const handleClear = () => {
        ajax.get('/hpl/clear/api')
            .then((response) => {
                message.success('清零成功');
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const isEditing = (record) => record.id === editingKey;

    const startEdit = (record) => {
        setEditingKey(record.id);
        setEditingData({
            id: record.id,
            is_use: record.is_use,
            is_usa: record.is_usa,
            is_book: record.is_book,
        });
    };

    const cancelEdit = () => {
        setEditingKey(null);
        setEditingData({});
    };

    const saveEdit = () => {
        setSaving(true);
        ajax.post('/hpl/account/show', editingData)
            .then(() => {
                message.success('修改成功');
                setState((prev) => prev.map((item) => (item.id === editingData.id ? { ...item, ...editingData } : item)));
                setEditingKey(null);
                setEditingData({});
            })
            .catch((err) => {
                console.log(err);
                message.error('修改失败');
            })
            .finally(() => setSaving(false));
    };
    const yesNoOptions = [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
    ];

    const renderYesNo = (field, value, record) => {
        if (isEditing(record)) {
            return (
                <Select
                    value={editingData[field]}
                    onChange={(v) => setEditingData((prev) => ({ ...prev, [field]: v }))}
                    options={yesNoOptions}
                    style={{ width: '100%' }}
                />
            );
        }
        return value == 1 ? '是' : value == 0 ? '否' : '';
    };
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            align: 'center',
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '用户名',
            dataIndex: 'username',
            align: 'center',
            sorter: (a, b) => a['username'].localeCompare(b['username']),
        },
        {
            title: '查询次数',
            dataIndex: 'use_count',
            align: 'center',
            width: 150,
            sorter: (a, b) => a?.use_count - b?.use_count,
        },
        {
            title: '是否查询',
            dataIndex: 'is_use',
            align: 'center',
            width: 150,
            sorter: (a, b) => a?.is_use - b?.is_use,
            render: (val, record) => renderYesNo('is_use', val, record),
        },
        {
            title: '是否美线',
            dataIndex: 'is_usa',
            align: 'center',
            width: 150,
            sorter: (a, b) => a?.is_usa - b?.is_usa,
            render: (val, record) => renderYesNo('is_usa', val, record),
        },
        {
            title: '是否订舱',
            dataIndex: 'is_book',
            align: 'center',
            width: 150,
            sorter: (a, b) => a?.is_book - b?.is_book,
            render: (val, record) => renderYesNo('is_book', val, record),
        },
        {
            title: '更新时间',
            dataIndex: 'update_time',
            align: 'center',
            sorter: (a, b) => +new Date(a.update_time) - +new Date(b.update_time),
        },
        {
            title: '操作',
            align: 'center',
            width: 150,
            render: (_, record) =>
                isEditing(record) ? (
                    <Space>
                        <Button type="link" onClick={saveEdit} loading={saving}>
                            保存
                        </Button>
                        <Button type="link" onClick={cancelEdit} disabled={saving}>
                            取消
                        </Button>
                    </Space>
                ) : (
                    <Button type="link" onClick={() => startEdit(record)} disabled={editingKey !== null && editingKey !== record.id}>
                        编辑
                    </Button>
                ),
        },
    ];

    return (
        <div className="list">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <PageHeader title="hpl账号列表" sticky></PageHeader>
                    <PageHeader content={promptText} sticky></PageHeader>
                </div>
                <Space style={{ marginRight: '3%' }}>
                    <Popconfirm title="确认" description="确认要清除吗?" okText="是" onConfirm={handleClear} cancelText="否">
                        <Button type="primary">清零账号</Button>
                    </Popconfirm>
                </Space>
            </div>
            {/* <Card className="ax-table-card">{renderTable()}</Card> */}
            <Table className="List" rowKey={(record) => record.id} pagination={false} dataSource={dataSource} columns={columns} />
        </div>
    );
}
